import { SettingsAPI } from "api/settings";
import { UsersAPI } from "api/users";
import { CustomerServerSettings } from "models/customers/customers";
import { RootState } from "store";
import { StateCreator } from "zustand";

export interface SettingsSlice {
  notification?: string[];
  outOfOfficeMessage: string;
  isSendingActivation?: boolean;
  isActivated?: boolean;

  sendingActivation: () => void;
  activationSent: () => void;
  updateUserSettings: (settings: CustomerServerSettings) => void;
  sendActivation: (email: string) => void;
  getSettings: () => void;
}

export const createSettingsSlice: StateCreator<
  RootState,
  [["zustand/devtools", never]],
  [],
  SettingsSlice
> = (set, get) => ({
  outOfOfficeMessage: "",

  sendingActivation: () =>
    set(
      ({ customerServerSettings }) => ({
        customerServerSettings: {
          ...customerServerSettings,
          isSendingActivation: true,
          isActivated: false
        }
      }),
      false,
      "settings/SENDING_ACTIVATION"
    ),

  activationSent: () =>
    set(
      ({ customerServerSettings }) => ({
        customerServerSettings: {
          ...customerServerSettings,
          isSendingActivation: false
        }
      }),
      false,
      "settings/ACTIVATION_SENT"
    ),

  updateUserSettings: (settings) =>
    set(
      ({ customerServerSettings }) => ({
        customerServerSettings: {
          ...customerServerSettings,
          notification: settings.notification,
          outOfOfficeMessage: settings.outOfOfficeMessage
        }
      }),
      false,
      "settings/UPDATE_USER_SETTINGS"
    ),

  sendActivation: async (email) => {
    set({}, false, "settings/SEND_ACTIVATION");
    try {
      get().customerServerSettings.sendingActivation();
      await UsersAPI.sendActivation(email);
      get().customerServerSettings.activationSent();
    } catch (error) {
      get().error.appendErrorNotification("Aktiveringsmeddelandet kunde inte skickas.", error);
    }
  },

  getSettings: async () => {
    set({}, false, "settings/GET_SETTINGS");
    try {
      const settings = await SettingsAPI.getSettings();
      get().customerServerSettings.updateUserSettings(settings);
    } catch (error) {
      get().error.appendErrorNotification(
        "Systemet kunde inte läsa in kundinställningarna.",
        error
      );
    }
  }
});
